module.exports = __webpack_public_path__ + "static/one-click-video-cbdd3ab46a9d28e71bb92f10c88edab4.png";